(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gs-catalog-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  function connectBackLinks() {
    let previous;
    try {
      previous = new URL(document.referrer);
    } catch {
      return;
    }
    if (previous.origin !== window.location.origin || previous.href === window.location.href) return;
    document.querySelectorAll('[data-gs-back]').forEach(link => {
      link.href = previous.href;
      if (link.dataset.gsBackReady) return;
      link.dataset.gsBackReady = 'true';
      link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (window.history.length > 1) {
          event.preventDefault();
          window.history.back();
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connectBackLinks, { once: true });
  } else {
    connectBackLinks();
  }
  window.addEventListener('pageshow', connectBackLinks);
  document.addEventListener('shopify:section:load', connectBackLinks);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gs-configurator-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-cart-editor')) {
  customElements.define('gs-cart-editor', class extends HTMLElement {
    async initialize({button, restore}) {
      this.button = button;
      this.text = JSON.parse(this.querySelector('[data-gs-edit-text]').textContent);
      this.lineKey = new URL(location.href).searchParams.get('gs_edit');
      this.ready = !this.lineKey;
      if (!this.lineKey) return;
      this.hidden = false;
      button.disabled = true;
      this.message(this.text.loading);
      try {
        const cart = await this.request('cart.js');
        const item = cart.items.find(line => line.key === this.lineKey && String(line.product_id) === this.dataset.productId);
        if (!item) throw new Error(this.text.missing);
        if (item.selling_plan_allocation) throw new Error(this.text.invalid);
        if (!restore(item)) throw new Error(this.text.invalid);
        this.item = item;
        this.ready = true;
        button.textContent = this.text.update;
        this.message(this.text.editing.replace('__QUANTITY__', item.quantity));
      } catch (error) {
        this.blocked = true;
        button.disabled = true;
        this.message(error.message || this.text.error, true);
      }
    }
    message(value, error = false) {
      this.hidden = false;
      this.querySelector('[data-gs-edit-message]').textContent = value;
      this.classList.toggle('is-error', error);
    }
    dimension(value) {
      const cleaned = String(value || '').replace(/["”]/g, '').trim();
      const fraction = cleaned.match(/[¼½¾]$/);
      if (fraction) return Number(cleaned.slice(0, -1).trim() || 0) + {'¼':.25,'½':.5,'¾':.75}[fraction[0]];
      return Number(cleaned);
    }
    select(control, value) {
      const candidate = String(value);
      if (![...control.options].some(option => option.value === candidate)) return false;
      control.value = candidate;
      return true;
    }
    async request(path, payload) {
      const response = await fetch(window.Shopify.routes.root + path, {
        method: payload ? 'POST' : 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {'Accept':'application/json', ...(payload ? {'Content-Type':'application/json'} : {})},
        ...(payload ? {body:JSON.stringify(payload)} : {})
      });
      const data = await response.json();
      if (!response.ok) {
        const error = new Error(typeof data.description === 'string' ? data.description : this.text.error);
        error.confirmedResponse = true;
        throw error;
      }
      return data;
    }
    sameItem(line) {
      return line && line.quantity === this.item.quantity && line.variant_id === this.item.variant_id && this.propertySignature(line.properties) === this.propertySignature(this.item.properties);
    }
    propertySignature(properties) {
      return JSON.stringify(Object.entries(properties || {}).sort(([a],[b]) => a.localeCompare(b)));
    }
    findOriginal(cart) {
      const exact = cart.items.find(line => line.key === this.item.key);
      if (exact) return exact;
      const matches = cart.items.filter(line => line.variant_id === this.item.variant_id && this.propertySignature(line.properties) === this.propertySignature(this.item.properties));
      if (matches.length > 1) throw new Error(this.text.changed);
      return matches[0];
    }
    async submit({id, quantity, properties}) {
      if (!this.ready || this.blocked || this.saving) throw new Error(this.text.review);
      this.saving = true;
      if (this.lineKey) this.button.textContent = this.text.saving;
      try {
        if (!this.item) {
          try {
            await this.request('cart/add.js', {items:[{id,quantity:quantity || 1,properties}]});
          } catch (error) {
            if (!error.confirmedResponse) { this.blocked = true; throw new Error(this.text.review); }
            throw error;
          }
          return;
        }
        const before = await this.request('cart.js');
        const original = this.findOriginal(before);
        if (!this.sameItem(original)) throw new Error(this.text.changed);
        const count = quantity == null ? this.item.quantity : quantity;
        const merged = {...this.item.properties, ...properties};
        if (Number(id) === this.item.variant_id) {
          try {
            await this.request('cart/change.js', {id:original.key,quantity:count,properties:merged});
          } catch (error) {
            this.blocked = true;
            throw new Error(this.text.review);
          }
          return;
        }
        const token = crypto.randomUUID();
        merged['_GS Edit'] = token;
        const findReplacement = cart => cart.items.find(line => line.properties?.['_GS Edit'] === token);
        try {
          await this.request('cart/add.js', {items:[{id,quantity:count,properties:merged}]});
        } catch (error) {
          try {
            const current = await this.request('cart.js');
            const added = findReplacement(current);
            if (added) await this.request('cart/change.js', {id:added.key,quantity:0});
          } catch (recoveryError) {
            this.blocked = true;
            throw new Error(this.text.review);
          }
          throw error;
        }
        try {
          const current = await this.request('cart.js');
          const added = findReplacement(current);
          if (!added || added.quantity !== count || !this.sameItem(this.findOriginal(current))) throw new Error(this.text.changed);
          await this.request('cart/change.js', {id:this.findOriginal(current).key,quantity:0});
        } catch (error) {
          try {
            const current = await this.request('cart.js');
            const added = findReplacement(current);
            if (!this.findOriginal(current) && added?.quantity === count) return;
            if (added) await this.request('cart/change.js', {id:added.key,quantity:0});
          } catch (recoveryError) {
            this.blocked = true;
            throw new Error(this.text.review);
          }
          throw error;
        }
      } catch (error) {
        this.message(error.message || this.text.error, true);
        throw error;
      } finally {
        this.saving = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gs-estimated-weight"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-estimated-weight')) {
  customElements.define('gs-estimated-weight', class extends HTMLElement {
    static get observedAttributes() { return ['dimensions']; }
    connectedCallback() { this.render(); }
    attributeChangedCallback() { this.render(); }
    render() {
      const output = this.querySelector('[data-weight-output]');
      if (!output) return;
      try {
        const pieces = JSON.parse(this.getAttribute('dimensions') || 'null');
        if (!Array.isArray(pieces) || !pieces.length) throw new Error('dimensions');
        const kind = this.dataset.kind;
        const density = this.dataset.veneer === 'true' ? 60 : kind === 'mantel' ? 48.5 : 49;
        const thickness = 0.75;
        const pounds = pieces.reduce((total, dimensions) => {
          if (!Array.isArray(dimensions) || dimensions.length !== 3 || dimensions.some(n => !Number.isFinite(n) || n <= 0)) throw new Error('dimensions');
          const [w, d, h] = dimensions;
          const area = kind === 'shelf' ? 2 * (w*d + w*h + d*h) : kind === 'mantel' ? w*h + 2*w*d + 2*d*h : 2*w*h + 2*d*h + w*d;
          return total + area * thickness * density / 1728;
        }, 0);
        output.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style:'unit', unit:'pound', unitDisplay:'short', maximumFractionDigits:1 }).format(pounds);
      } catch { output.textContent = '—'; }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gs-paint-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-paint-picker')) {
  customElements.define('gs-paint-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.colors = JSON.parse(this.querySelector('[data-colors]').textContent);
      this.text = JSON.parse(this.querySelector('[data-text]').textContent);
      this.program = this.dataset.gallery ? 'custom' : 'standard';
      this.querySelector('input[data-search]')?.addEventListener('input', () => this.filter());
      if (this.dataset.gallery) this.render();
    }
    mount(select) {
      if (this.select) return;
      this.select = select;
      const palette = {'Alabaster SW 7008':'#EDEAE0','Natural Linen SW 9109':'#DFD3C3','Universal Khaki SW 6150':'#B8A992','Halcyon Green SW 6213':'#9BAAA2','Tricorn Black SW 6258':'#2F2F30'};
      this.standard = Array.from(select.options).map(option => {
        const code = option.value.match(/SW\s*\d{4}/)?.[0] || '';
        return {name:option.value.replace(/\s*SW\s*\d{4}$/,''),code,hex:option.dataset.hex || palette[option.value],value:option.value};
      });
      const standardCodes = new Set(this.standard.map(color => color.code.replace(/\s/g,'')));
      this.colors = this.colors.filter(color => !standardCodes.has(color.code.replace(/\s/g,'')));
      const group = document.createElement('optgroup');
      group.label = this.querySelector('[data-custom-heading]').textContent;
      this.colors.forEach(color => {
        const option = document.createElement('option');
        option.value = this.valueFor(color);
        option.textContent = `${color.name} ${color.code} (+$65)`;
        option.dataset.hex = color.hex;
        group.append(option);
      });
      select.append(group);
      const requested = new URL(location.href).searchParams.get('gs_color');
      const match = this.entries().find(color => color.code.replace(/\s/g,'') === String(requested || '').replace(/\s/g,''));
      if (match) select.value = match.value;
      select.hidden = true;
      select.addEventListener('change', () => this.sync());
      this.sync();
    }
    valueFor(color) { return `Custom — ${color.name} ${color.code}`; }
    normalizeValue(value) {
      const code = String(value || '').match(/SW\s*\d{4}/)?.[0].replace(/\s/g,'');
      return this.standard?.find(color => color.code.replace(/\s/g,'') === code)?.value || value;
    }
    entries() { return [...(this.standard || []), ...this.colors.map(color => ({...color,value:this.valueFor(color)}))]; }
    get premium() { return this.select?.value.startsWith('Custom — ') ? 65 : 0; }
    get properties() {
      const value = this.select?.value || '';
      const clean = value.replace(/^Custom — /,'');
      return {'Sherwin-Williams Color':clean,'SW Color Code':clean.match(/SW\s*\d{4}/)?.[0] || '', 'Paint Color Name':clean.replace(/\s*SW\s*\d{4}$/,''),'Color Program':this.premium ? 'Custom — Top 50' : 'Standard','Custom Color Upgrade':this.premium ? `$65 per ${this.dataset.perSet ? 'set' : 'item'}` : 'Included'};
    }
    choose(color) {
      if (this.select) {
        this.select.value = color.value;
        this.select.dispatchEvent(new Event('change',{bubbles:true}));
      } else {
        this.galleryValue = color.value;
        this.closest('section').querySelectorAll('.gs-color-products a').forEach(link => {
          const url = new URL(link.href);url.searchParams.set('gs_color',color.code.replace(/\s/g,''));link.href = url.toString();
        });
        this.sync();
      }
    }
    sync() {
      if (!this.select && !this.dataset.gallery) return;
      if (this.select) this.program = this.premium ? 'custom' : 'standard';
      const value = this.select?.value || this.galleryValue || '';
      if (!this.rendered) this.render();
      const selected = this.entries().find(color => color.value === value);
      this.querySelector('.gs-color-selected').hidden = !selected;
      if (selected) {
        this.querySelector('[data-selected-chip]').style.backgroundColor = selected.hex;
        this.querySelector('[data-selected-name]').textContent = `${this.text.selected}: ${selected.name} · ${selected.code}${this.premium ? ` · +$65 per ${this.dataset.perSet ? 'set' : 'item'}` : ''}`;
      }
      this.querySelectorAll('.gs-color-card').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.value === value)));
    }
    render() {
      this.querySelectorAll('.gs-color-grid').forEach(grid => grid.replaceChildren());
      this.entries().forEach(color => {
        const grid = this.querySelector(color.value.startsWith('Custom — ') ? '[data-custom-grid]' : '[data-standard-grid]');
        const button = document.createElement('button');
        button.type = 'button';button.className = 'gs-color-card';button.dataset.value = color.value;
        button.dataset.search = `${color.name} ${color.code} ${color.code.replace(/\s/g,'')}`.toLowerCase();
        button.setAttribute('aria-label',`${color.name}, ${color.code}`);button.setAttribute('aria-pressed','false');
        const chip = document.createElement('i');chip.style.backgroundColor = color.hex;chip.setAttribute('aria-hidden','true');
        const name = document.createElement('span');name.textContent = color.name;
        const code = document.createElement('small');code.textContent = color.code;
        button.append(chip,name,code);button.addEventListener('click',()=>this.choose(color));grid.append(button);
      });
      this.rendered = true;
      this.filter();
      if (this.dataset.gallery && !this.galleryValue) this.querySelector('.gs-color-selected').hidden = true;
    }
    filter() {
      const search = this.querySelector('input[data-search]');
      if (!search) return;
      const query = search.value.trim().toLowerCase();
      let count = 0;
      this.querySelectorAll('.gs-color-card').forEach(button => {button.hidden = !button.dataset.search.includes(query);if (!button.hidden && button.dataset.value.startsWith('Custom — ')) count++;});
      this.querySelector('[data-count]').textContent = `${count} / ${this.colors.length} ${this.text.count}`;
      this.querySelector('[data-empty]').hidden = count !== 0;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gs-surface-filter"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('gs-surface-filter'))customElements.define('gs-surface-filter',class extends HTMLElement{
 connectedCallback(){this.select=this.querySelector('select');this.onChange=()=>this.apply();this.select.addEventListener('change',this.onChange);document.addEventListener('collection:rerendered',this.onChange);this.apply()}
 disconnectedCallback(){this.select?.removeEventListener('change',this.onChange);document.removeEventListener('collection:rerendered',this.onChange)}
 apply(){const root=document.getElementById(this.dataset.section);if(!root)return;let count=0;root.querySelectorAll('[data-gs-surface]').forEach(card=>{card.hidden=!!this.select.value&&card.dataset.gsSurface!==this.select.value;if(!card.hidden)count++});const status=this.querySelector('[data-gs-matches]');const total=root.querySelectorAll('[data-gs-surface]').length;status.textContent=status.dataset.label.replace('__SHOWN__',count).replace('__TOTAL__',total);const nativeCount=root.querySelector('#ProductCount');if(nativeCount)nativeCount.textContent=status.textContent;this.querySelector('[data-gs-empty]').hidden=count!==0}
});
  } catch(e) { console.error(e); }
})();

})();
